import {
  ADD_FILTER,
  CLEAR_FILTER,
  RECALCULATION_FILTER,
  REMOVE_TAG,
  SET_INITIAL_SELECTORS_VALUES,
} from "../constans";

export const clearFilter = (filterType) => async (dispatch) => {
    dispatch({
      type: CLEAR_FILTER,
      payload: { filterType },
    });
};

export const recalculationFilter = (filterType, isClear) => async (dispatch) => {
  dispatch({
    type: RECALCULATION_FILTER,
    payload: {filterType}
  });
};



export const setInitialSelectsValues = (selectsOptionsDependsSchema) => async (dispatch) => {
    dispatch({
      type: SET_INITIAL_SELECTORS_VALUES,
      payload: {
        selectsOptionsDependsSchema
      },
    });
}

export const addFilter = (value, filterType, isMultiSelect) => async (dispatch) => {
    dispatch({
      type: ADD_FILTER,
      payload: {
        filterType,
        value,
        isMultiSelect
      },
    });
    dispatch(recalculationFilter(filterType))
};

export const removeTag = (value, filterType) => async (dispatch) => {
    dispatch({
      type: REMOVE_TAG,
      payload: {
        filterType,
        value
      },
    });
    dispatch(recalculationFilter(filterType))
};
